import { callApi } from '../apiCaller';
import { addTimezoneLocal } from '../utils';

import {
     API_SUBSCRIBER_ORGANIZATION_USER,
     LOCAL_CART,
     LOCAL_COUPON,
     LOCAL_COUPON_VOUCHERS,
     LOCAL_ORG_USER,
     ORG_USER_ROLES,
     SUBSCRIBER_PATH,
} from '../constants';

import { setCurrentCountry } from '../components/CMS/Subscriber/GlobalStates/CurrentCountry/actions';
import { setOrganizationCourses } from '../components/CMS/Organizations/OrganizationCourses/actions';
import { setOrganizationMembers } from '../components/CMS/Organizations/OrganizationMembers/actions';
import { setOrganizationTrainingGroups } from '../components/CMS/Organizations/TrainingGroups/actions';
import { actionClearCart, actionRemoveCartVoucherRule } from '../components/CMS/Guest/Cart/actions';

export const switchOrg = async ({ managedOrganizations, organizationId, myPurchasePath, dispatch, navigate }) => {
     let listManager = managedOrganizations;

     if (!managedOrganizations) {
          try {
               const managerOrg = await callApi(API_SUBSCRIBER_ORGANIZATION_USER, 'GET');
               if (managerOrg.status === 200) {
                    listManager = managerOrg.data;
               }
          } catch (error) {
               console.log('Switch organization:: ', error);
               return;
          }
     }

     let orgId = organizationId;

     if (!orgId) {
          const organizations = listManager?.filter((org) => org.role !== ORG_USER_ROLES.USER).map((item) => item.organization) ?? [];
          orgId = organizations[0].id;
     }

     const organizationOwnerSelected = listManager?.find((item) => item.organizationId === orgId);

     if (organizationOwnerSelected) {
          addTimezoneLocal(organizationOwnerSelected.organization.timezone);
          localStorage.setItem(LOCAL_ORG_USER, JSON.stringify(organizationOwnerSelected));
          dispatch(setCurrentCountry(organizationOwnerSelected.organization.country));
     }

     localStorage.removeItem(LOCAL_CART);
     localStorage.removeItem(LOCAL_COUPON);
     localStorage.removeItem(LOCAL_COUPON_VOUCHERS);

     dispatch(setOrganizationTrainingGroups([]));
     dispatch(setOrganizationMembers(null));
     dispatch(setOrganizationCourses([]));
     dispatch(actionRemoveCartVoucherRule());
     dispatch(actionClearCart());

     navigate(myPurchasePath || SUBSCRIBER_PATH.ORGANIZATIONS_DASHBOARD, { replace: true });
};

export const checkAcceptSeatLayout = (locationPath) => {
     let isAcceptSeatLayout = false;

     if (locationPath?.includes('verify-seat') || locationPath?.includes('accept-your-seats')) {
          isAcceptSeatLayout = true;
     }

     return isAcceptSeatLayout;
};
